/**
 * Conversation modes — the four surfaces a conversation can run as, always derived from the URL
 * (never persisted). Owned by the Conversation slice; mirrors the backend's ConversationMode,
 * kept coarse (the backend's TEACHER_TOOLS_* sub-modes all map to 'teacher-tools' here).
 */
export const CONVERSATION_MODES = Object.freeze({
  STUDY: 'study',
  PRACTICE: 'practice',
  REVISION: 'revision',
  TEACHER_TOOLS: 'teacher-tools',
} as const);

export type ConversationMode = (typeof CONVERSATION_MODES)[keyof typeof CONVERSATION_MODES];
